import { useLazyQuery, useMutation } from "@apollo/client/react";
import { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GET_LISTA_PRECIOS_MASIVOS } from '../../../data/graphQL/queries/GestionPrecioMasivo/getListaPreciosMasivos';
import { adaptPrecioMasivoArray } from '../../../adapters/precioMasivoAdapter';
import { CustomChip } from '../../../components/chip/Chip';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Grid } from '@mui/material';
import * as XLSX from 'xlsx';
import IconButton from '@mui/material/IconButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { styled } from '@mui/material/styles';
import { IMPORTAR_PRECIO_MASIVO } from '../../../data/graphQL/mutations/GestionPrecioMasivo/importarPrecioMasivo';
import toast from 'react-hot-toast';


const locale = "es-ES";
const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

export const GestionPrecioMasivoAll = ({ setChildrenAction }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openDlgPrecios, setOpenDlgPrecios] = useState(false);
  const [subirArchivo, setSubirArchivo] = useState(false);
  const [fileSelected, setFileSelected] = useState();
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [precios, setPrecios] = useState([]);
  const [state, setState] = useState({
    file: {},
    data: [],
    cols: [],
    isEmpty: true
  });

  const rutasStorage = localStorage.getItem('navigationRoutes');
  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;
      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  useEffect(() => {
    if (allowedWrite) {
      setChildrenAction(() =>
      <div className='insumos-all'>
                    <CustomButton
          variant='outlined'
          className='margin-right'
          title='Importar Archivo'
          onClick={handlePreciosMasivos}>
          
                        Importar
                    </CustomButton>
                    <Link to="/files/precios-masivos.xls" target="_blank" download>
                        <CustomButton
            variant='outlined'
            className='margin-right'>
            
                            Descargar
                        </CustomButton>
                    </Link>
                </div>
      );
    }

  }, [setChildrenAction, precios, allowedWrite]);

  const [getPreciosMasivos, { data: preciosData, loading: preciosLoading }] = useLazyQuery(GET_LISTA_PRECIOS_MASIVOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!preciosData) return;
    setPrecios(adaptPrecioMasivoArray(preciosData));
  }, [preciosData]);


  const [importar, { error: importarError, loading: importarLoading }] = useMutation(IMPORTAR_PRECIO_MASIVO, {
    onCompleted: (data) => {
      if (data.importarPrecioMasivo) {
        toast.success("El proceso se ejecuto en forma satisfactoria.");
        setOpenDlgPrecios(false);
        limpiarPopUp();
        getPreciosMasivos();
      } else {
        toast.error("Se produjo un error en el proceso");
      }
    }
  });

  useEffect(() => {
    if (!preciosLoading) {
      getPreciosMasivos();
    }
  }, []);

  const getChipEstado = (estado) => {
    switch (estado) {
      case "Pendiente":
        return (
          <CustomChip label={estado} isYellow />);
      case "Modificado":
        return (
          <CustomChip label={estado} isGreen />);
      default:
        return null;
    }
  };

  const handleView = (row) => {
    navigate('/gestionPrecioMasivo/precioMasivo', {
      state: {
        allowedWrite: allowedWrite,
        precio: row
      }
    });
  };

  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 0.1,
    cellClassName: 'grid-actions-column',
    maxWidth: 40,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <>
                        <div className='popover-modal-content'>
                            <div onClick={() => handleView(row)} aria-hidden='true'
            className='item-option'>
              
                                <VisibilityIcon className='edit-icon' />
                            </div>
                        </div>
                    </>);

    }
  },
  {
    field: 'idPreciosMasivos',
    headerName: '#',
    flex: 0.15
  },
  {
    field: 'fechaIngreso',
    flex: 0.25,
    headerName: 'Ingreso',
    type: 'date',
    limitDate: 2000
  },
  {
    field: 'cantidad',
    headerName: 'Cantidad'
  },
  {
    field: 'estado',
    flex: 0.25,
    align: 'center',
    headerName: 'Estado',
    headerAlign: 'center',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return getChipEstado(row.estado);
    }
  },
  {
    field: 'autorizador',
    headerName: 'Autorizador',
    flex: 0.4
  },
  {
    field: 'solicitante',
    headerName: 'Solicitante',
    flex: 0.4
  },
  {
    field: 'usuarioEjecutador',
    flex: 0.4,
    headerName: 'UsuarioEjecutador'
  },
  {
    field: 'fechaEjecucion',
    type: 'date',
    flex: 0.25,
    headerName: 'Ejecución'
  },
  {
    field: 'observaciones',
    headerName: 'Observaciones',
    flex: 0.7
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [allowedWrite, precios]);

  useEffect(() => {
    if (subirArchivo)
    handleFile();

    console.log(state);
  }, [state.file]);

  const isValidTipoArchivo = () => {
    return FILE_TYPE.some((e) => e === fileSelected);
  };

  const handleFile = () => {
    try {

      if (isValidTipoArchivo()) {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */

          setState((prevState) => {
            return {
              ...prevState,
              data: data,
              make_cols: make_cols(ws['!ref']),
              isEmpty: false
            };
          });
        };

        if (rABS) {
          reader.readAsBinaryString(state.file);
        } else {
          reader.readAsArrayBuffer(state.file);
        };
      } else
      {
        toast.error("El tipo de archivo adjunto no está permitido.");
      }
    } catch (e) {
      console.log("Empty!");
    }
  };

  const handlePreciosMasivos = () => {
    setOpenDlgPrecios(true);
  };

  const isFormValid = () => {
    if (state.data.length <= 0) {
      toast.error('Debe seleccionar un archivo');
      return false;
    }

    return true;
  };

  const handleCloseDlgPrecios = () => {
    setOpenDlgPrecios(false);
    limpiarPopUp();
  };

  const make_cols = (refstr) => {
    let o = [],C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
  };

  const limpiarPopUp = () => {
    setState((prevState) => {
      return {
        ...prevState,
        file: {},
        data: [],
        cols: [],
        isEmpty: true
      };
    });
  };

  const handleAceptarPrecios = () => {
    let contratos = state.data.map(function (item) {
      return item['CONTRATO'] + ', ' + item['PRECIO MODIFICADO'];
    }).toString();
    console.log(contratos);

    if (isFormValid())
    importar({ variables: { contratos: contratos } });
  };

  const Input = styled('input')({
    display: 'none'
  });

  const handleChange = (e) => {
    setSubirArchivo(true);
    const files = e.target.files;
    setFileSelected(files[0].type);

    if (files && files[0])
    setState((prevState) => {
      return {
        ...prevState,
        file: files[0]
      };
    });
  };

  const initialColumnsExcel = [
  {
    field: 'CONTRATO',
    headerName: 'Contrato'
  },
  {
    field: 'PRECIO MODIFICADO',
    headerName: 'Precio Modificado'
  }];


  const columnsExcel = generateColumnsDefaultConfiguration(initialColumnsExcel);

  return (
    <>
            <DataGridGenerico
        columns={columns}
        rows={precios ?? []}
        toolbar={false}
        loading={preciosLoading} />
      

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgPrecios}
        title={'Carga de precios masivos'}
        onAccept={handleAceptarPrecios}
        onCancel={handleCloseDlgPrecios}
        cancelText='Cerrar'>
        
                <Grid
          container
          spacing={0}
          direction="row"
          alignItems="left"
          justifyContent="left">
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '0%' }} size={{ xs: 12, md: 6, lg: 4 }}>
                        <label htmlFor="icon-button-file">
                            <Input accept="xlsx/xls" onChange={handleChange} id="icon-button-file" type="file" />
                            <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                <CloudUploadIcon fontSize="inherit" />
                            </IconButton>
                        </label>
                    </Grid>
                </Grid>
                <DataGridGenerico
          columns={columnsExcel}
          rows={state.data}
          toolbar={false} />
        
            </CustomDialog>
        </>);

};